<template>
  <div class="page">
    <scanner
      v-if="!loader"
      ref="scanner"
      title="Пропуск"
      page-title="Въезд/Выезд"
      @input="scanPass"
    />
    <app-loader v-if="loader" />
    <template v-else-if="mode === 'check-in'">
      <div
        v-if="scannedDriver"
        class="page__wrapper"
      >
        <v-card
          elevation="1"
          color="success lighten-5"
        >
          <v-card-text>
            {{ scannedDriver.driver }} <br>
            {{ scannedDriver.gosNumber }} <br>
            {{ scannedDriver.model }}
          </v-card-text>
        </v-card>
      </div>
      <div
        v-else-if="isPassScanned && !scannedDriver"
        class="not-found text-center mt-3"
      >
        Нет заявок
      </div>
    </template>
    <template v-else-if="mode === 'check-out'">
      <div class="page__wrapper">
        <v-card
          v-for="it in cars"
          :id="it.vin"
          :key="it.vin"
          elevation="1"
          color="success lighten-5"
          class="mb-5"
        >
          <v-card-text>
            {{ it.vin }} <br>
            <span class="text-transform-none">{{ it.model }}, {{ it.color }}</span>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <div
      v-if="!isScannerShown"
      class="page__actions"
    >
      <v-btn
        color="error lighten-1"
        x-large
        @click="goToNavigation"
      >
        Назад
      </v-btn>
      <v-btn
        class="mx-1"
        color="primary"
        x-large
        @click="$router.push('/navigation')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn
        v-if="isAcceptBtnShown"
        color="success"
        class="ml-auto"
        x-large
        @click="confirmationModal = true"
      >
        {{ acceptBtnText }}
      </v-btn>
    </div>
    <result-modal
      v-model="acceptRequestResultModal"
      :title="acceptRequestModalText"
      :text="scannedDriver && scannedDriver.driver"
      success
      @close="goToNavigation"
    />
    <result-modal
      v-model="scanPassResultModal"
      :title="scannedDriver && scannedDriver.driver"
      :text="scannedDriver && `№${scannedDriver.gosNumber}`"
      success
    />
    <result-modal
      v-model="errorModal"
      :title="errorText"
      error
    />
    <confirmation-modal
      v-model="confirmationModal"
      @submit="acceptCarCarrier"
    />
  </div>
</template>

<script>
import Scanner from '@/components/Scanner.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import ResultModal from '@/components/ResultModal.vue';
import { mapState } from 'vuex';

export default {
  name: 'CarCarriers',
  components: {
    Scanner,
    ConfirmationModal,
    ResultModal,
  },
  data: () => ({
    loader: false,
    acceptLoader: false,
    confirmationModal: false,
    acceptRequestResultModal: false,
    scanPassResultModal: false,
    errorModal: false,
    errorText: '',
    scannedDriver: null,
    isPassScanned: false,
    cars: [],
    activeCarrier: null,
    requestId: null,
  }),
  computed: {
    ...mapState(['isScannerShown']),
    mode() {
      return +this.scannedDriver?.EntryExit ? 'check-out' : 'check-in';
    },
    isAcceptBtnShown() {
      return this.requestId && !this.loader && !this.acceptLoader && (
        (this.mode === 'check-in' && this.scannedDriver)
        || (this.mode === 'check-out' && !this.errorModal)
      );
    },
    scanPassRequestUrl() {
      return `MobileOperatorInterface/CarrierEntryRequestPassCarriers/RequestPassCarrier/Document/${this.requestId}`;
    },
    exitConfirmationRequestUrl() {
      return `/MobileOperatorInterface/CarrierExit/ConfirmationExit/${this.requestId}`;
    },
    acceptRequestUrl() {
      if (this.mode === 'check-in') {
        return this.scanPassRequestUrl;
      }
      return this.exitConfirmationRequestUrl;
    },
    acceptRequestModalText() {
      return this.mode === 'check-in' ? 'Въезд подтвержден' : 'Выезд подтвержден';
    },
    acceptBtnText() {
      if (this.mode === 'check-in') {
        return 'Пропустить';
      }
      return this.cars.length ? 'Выпустить' : 'Пустой';
    },
  },
  watch: {
    acceptRequestResultModal(val) {
      if (!val) {
        this.stopScanning();
      }
    },
    scanPassResultModal(val) {
      if (!val) {
        this.stopScanning();
      }
    },
  },
  methods: {
    async scanPass(requestId) {
      this.requestId = requestId;
      try {
        this.loader = true;
        const { data: scannedDriver } = await this.$http.get(this.scanPassRequestUrl)
          .catch((e) => {
            this.onErrorHandler(e);
          });
        this.scannedDriver = scannedDriver;
        this.isPassScanned = true;

        if (this.mode === 'check-out') {
          const { data: cars } = await this.$http.get(`MobileOperatorInterface/RequestPassCarriers/Document/${scannedDriver?.requestID}`)
            .catch((e) => {
              this.onErrorHandler(e);
            });
          this.cars = cars;
          this.scanPassResultModal = true;
        }
      } finally {
        this.loader = false;
      }
    },
    stopScanning() {
      this.$refs.scanner.stopScanning();
    },
    acceptCarCarrier() {
      this.acceptLoader = true;
      this.$http.post(this.acceptRequestUrl).then(() => {
        this.acceptRequestResultModal = true;
      }).catch((e) => {
        this.onErrorHandler(e);
      }).finally(() => {
        this.acceptLoader = false;
      });
    },
    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = (e?.response?.data?.errorMess || 'Ошибка сервера').replace(': 500', '');
    },
    goToNavigation() {
      this.$router.push('/navigation');
    },
  },
};
</script>

<style>
.not-found {
  font-size: 20px;
}

.text-transform-none {
  text-transform: none !important;
}
</style>
